import { render, staticRenderFns } from "./BusinessNameRegistrationActivity.vue?vue&type=template&id=dde81e42&scoped=true&"
import script from "./BusinessNameRegistrationActivity.vue?vue&type=script&lang=js&"
export * from "./BusinessNameRegistrationActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde81e42",
  null
  
)

export default component.exports